export default __webpack_public_path__ + "static/media/etoile_son.ac1c04ae.mp3";